









import { Vue, Component, Prop } from 'vue-property-decorator'
import { Patient, Worker, isWorker, Relative, isRelative } from '@/types/user'
import { DatetimeString } from '@/types/utils'
import dayjs from 'dayjs'

@Component
export default class CallHistoryLogUser extends Vue {
  @Prop() user!: Patient | Worker | Relative
  @Prop(String) startTime?: DatetimeString
  @Prop(String) endTime?: DatetimeString
  @Prop({ default: true }) showEndTime?: boolean

  get occupation() {
    if (isWorker(this.user)) {
      return this.user.occupation.name
    }
    return isRelative(this.user) ? '家族' : '患者'
  }
  get name() {
    return `${this.user.lastName}${this.user.firstName}`
  }
  get startTimeStr() {
    return this.startTime ? this.getTimeStr(this.startTime) : ''
  }
  get endTimeStr() {
    return this.endTime ? this.getTimeStr(this.endTime) : ''
  }
  getTimeStr(time: DatetimeString) {
    return dayjs(time).format('HH:mm')
  }
}
